import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import UnitHome from "./UnitHome";

export default function UnitList() {
  const { t } = useTranslation();
  return (
      <Fragment>
            <Breadcrumbs mainTitle={t("List of Units")} parent={t("Home")} title={t("List of Units")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <UnitHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
  )
}
